module.exports = __webpack_public_path__ + "img/2306049-48-71.15215870.png";